export default __webpack_public_path__ + "static/media/capman.f44d8487.svg";